import React from "react";
import { Card, CardColumns } from "react-bootstrap";
import { CCAssessmentType, CCEnrollment } from "../../../Physician/Models/CCEnrollment";
import { AvailableExamination } from "../Models/AvailableExamination";
import AvailableExaminationCard from "./AvailableExaminationCard";
 
interface IProps {
    examinations: Array<AvailableExamination>;
    title: string;
    currentCCEnrollment: CCEnrollment;
    isFullyLapsed: boolean;
}

export default function AvailableExaminationGroup(props: IProps){

    const filteredExaminations = () => {
        var exams = new Array<AvailableExamination>();
        props.examinations.map((exam: AvailableExamination) => {
            if(exam.availableModuleCertifications.length > 0){
                const ccEnrollmentExamCertificates = props.currentCCEnrollment?.activeEnrollmentCertificates.filter(_ => _.ccAssessmentType == CCAssessmentType.Exam);
                if(ccEnrollmentExamCertificates != null){
                    var ccEnrollmentExamCertificationIds = ccEnrollmentExamCertificates.map(_ => _.certification_Key);
                    var filteredCertifications = exam.availableModuleCertifications.filter(_ => ccEnrollmentExamCertificationIds.indexOf(_.certificationId) != -1);
                    if(filteredCertifications.length > 1)
                        exams.push(exam);
                }
                else
                    exams.push(exam);
            }
            else
                exams.push(exam);
        });

        return exams;
    }

    return (
        <React.Fragment key={props.title}>
            <p className="font-weight-bold text-pp-secondary ">{props.title}</p>
            { props.examinations.length > 0 ? 
                <CardColumns bsPrefix="pp-card-columns">
                    {filteredExaminations().map((exam: AvailableExamination) =>  { return <AvailableExaminationCard applyLinkTo = {`Apply/${exam.examinationId}`} examination={exam} currentCCEnrollment={props.currentCCEnrollment} isFullyLapsed={props.isFullyLapsed}/> })}
                </CardColumns>
                :
                <Card.Text bsPrefix="ml-2">No available applications</Card.Text> }              
        </React.Fragment>
    );
}